// extracted by mini-css-extract-plugin
export default {"receiverGroupCard":"ReceiverGroupCard_receiverGroupCard__Iwwrl"};